import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { vRequired, vNumberIntegerPositive } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { Textarea } from 'components/Input/Textarea'
import { Input } from 'components/Input/Input'
import SelectPretty from 'components/Input/SelectPretty'
import UploadAudioForPorta from '../PortaSayPlay/UploadAudioForPorta.container'

export default class GatherInputForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData } = this.props
    const submit = data => onSubmit(node, { extras: data })

    const voiceOptions = [
      {
        name: 'Male',
        value: 'man',
      },
      {
        name: 'Female',
        value: 'woman',
      },
    ]

    const audio = formData.audio || {}

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Read a message out to the caller and listen for their key-pad input. For example, "Press 1
          for marketing, Press 2 for billing".{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            Learn more.
          </a>
        </div>

        <Field
          name="loop"
          component={Input}
          type="number"
          label="Number of loops"
          // info="Set to '0' to loop indefinitely"
          // validate={[vNumberIntegerPositive]}
        />

        <Field
          name="timeout"
          component={Input}
          type="number"
          label="Timeout"
          info="Ignored if output X is not connected"
          validate={[vNumberIntegerPositive]}
        />

        {!audio.original && (
          <>
            <Field
              label="Message"
              name="message"
              component={Textarea}
              display="standard"
              validate={[vRequired]}
            />

            <Field
              name="voice"
              component={SelectPretty}
              options={voiceOptions}
              label="Voice"
              validate={[vRequired]}
            />

            <div style={{ padding: '15px 0' }} className={sText.descrip3}>
              Alternatively, upload your own audio file/hold music.
            </div>
          </>
        )}

        <Field name="audio" component={UploadAudioForPorta} />

        <div className={sLay.flex} />

        <div className={cn(sLay['layout-column'])} style={{ marginTop: '20px' }}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaGatherInput/GatherInputForm.jsx